const shouldShowBannerUtil = ({
  hasDeluxeSample,
  wasLikedProductVariant,
  wasSuperLikedProductVariant,
  wasNotDeliveredProductVariant,
  isFullSize,
  wasDislikedProductVariant,
  needsToBeRatedSample,
  shouldShowDealTimer
}
) => {
  if (shouldShowDealTimer) {
    return true
  }

  // If disliked, don't show banner
  if (wasDislikedProductVariant) {
    return false
  }

  // If full size, show banner if either liked, super liked
  if (isFullSize &&
      (wasLikedProductVariant ||
      wasSuperLikedProductVariant)) {
    return true
  }

  // If not full size, show banner if either liked, super liked, not delivered, has deluxe sample, or needs to be rated sample
  if (!isFullSize &&
      (wasLikedProductVariant ||
      wasSuperLikedProductVariant ||
      wasNotDeliveredProductVariant ||
        hasDeluxeSample ||
        needsToBeRatedSample)) {
    return true
  }

  return false
}

export default shouldShowBannerUtil
